var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiToolbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 2.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.25,
    y: 3.9,
    width: 1.5,
    height: 2.6,
    rx: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10.4,
    width: 2.1,
    height: 4.4,
    rx: 1.05
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.9,
    y: 10.4,
    width: 2.1,
    height: 4.4,
    rx: 1.05
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.2 6.4h11.6a3 3 0 013 3v6.4a3 3 0 01-3 3H6.2a3 3 0 01-3-3V9.4a3 3 0 013-3zM9 10.1a1.7 1.7 0 100 3.4 1.7 1.7 0 000-3.4zm6 0a1.7 1.7 0 100 3.4 1.7 1.7 0 000-3.4zm-6.4 5.4a.6.6 0 000 1.2h6.8a.6.6 0 000-1.2H8.6z"
  }))));
}
export default SvgAiToolbox;